import { Pipe, PipeTransform } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';

@Pipe({
  name: 'characterCounter',
  pure: false, //ensuraes real time updates
  standalone: false,
})
export class CharacterCounterPipe implements PipeTransform {
  private readonly defaultMaxLength: number = 2000;
  transform(
    controlOrValue: AbstractControl | null,
    maxLength: number = this.defaultMaxLength,
    fieldName?: string
  ): string {
    if (!controlOrValue) return `0/${maxLength}`;

    let value: string = '';

    // If it's a control, use existing logic
    if (controlOrValue instanceof AbstractControl) {
      const control: AbstractControl = controlOrValue;

      if (control instanceof FormControl) {
        value = control.value || '';
      } else if (control instanceof FormArray) {
        value = this.getFormArrayValue(control, fieldName);
      } else if (control instanceof FormGroup && fieldName) {
        value = this.getFormGroupValue(control, fieldName);
      }
    } else {
      // Note: controlOrValue is always truthy here because falsy values
      // are caught by the early return on line 20
      value = controlOrValue;
    }

    //value = value?.replace(/\s+/g, ''); // Remove spaces before counting
    //value = value.toString().replace(/<[^>]*>/g, '');

    return `${value.length}/${maxLength}`;
  }

  private getFormArrayValue(formArray: FormArray, fieldName?: string): string {
    return formArray.controls
      .map((control) => this.getAbstractControlValue(control, fieldName))
      .join('');
  }

  private getFormGroupValue(formGroup: FormGroup, fieldName: string): string {
    const fieldControl: AbstractControl | null = formGroup.get(fieldName);
    if (fieldControl instanceof FormControl) {
      return (fieldControl.value || '').toString();
    }
    return '';
  }

  private getAbstractControlValue(
    control: AbstractControl,
    fieldName?: string
  ): string {
    if (control instanceof FormControl) {
      if (
        fieldName &&
        typeof control.value === 'object' &&
        control.value[fieldName]
      ) {
        return control.value[fieldName].toString();
      }
      return (control.value || '').toString();
    }
    if (control instanceof FormArray) {
      return this.getFormArrayValue(control, fieldName);
    }
    return '';
  }
}
